import { useNewCode } from '@calendly/feature-check-react';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { CloseCircleIcon, CloseMiniIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getContactDisplayName } from 'shared/utils/get_contact_display_name';
import { CRM_NEEDS_ATTENTION_FLAG_KEY, getNonContactRecipientLabel, isGmailRecipientWithBrandmark, isTypedNonContactRecipient } from 'shared/utils/non_contact_recipient';
import { ContactRecipientAvatar } from './contact_recipient_avatar';
const containerIsInvalidCss = "cy96qr3";
const containerIsEditModeCss = "clo0zru";
const containerIsSingleCss = "c8cib30";
const containerIsNonContactCss = "cxsux9z";
const containerIsGmailCss = "c1nkbl9g";
const containerCss = "c1i0br8h";
const Container = forwardRef((props, ref) => {
  const {
    isInvalid,
    isEditMode,
    isSingle,
    isNonContact,
    isGmail,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsInvalidCss]: isInvalid,
    [containerIsEditModeCss]: isEditMode,
    [containerIsSingleCss]: isSingle,
    [containerIsNonContactCss]: isNonContact && !isGmail,
    [containerIsGmailCss]: isGmail
  }, props.className)} />;
});
const contactContainerCss = "cnfniqj";
const ContactContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(contactContainerCss, props.className)} />;
});
const deleteTagButtonCss = "d1my9kcv";
const DeleteTagButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(deleteTagButtonCss, props.className)} />);
const ContactItem = ({
  contact,
  isNonContactUiEnabled
}) => {
  const isTypedNonContact = isNonContactUiEnabled && isTypedNonContactRecipient(contact);
  const displayLabel = isTypedNonContact ? getNonContactRecipientLabel(contact) : getContactDisplayName(contact);
  const showGmailBrandmark = isNonContactUiEnabled && isGmailRecipientWithBrandmark(contact);
  return <ContactContainer>
      <ContactRecipientAvatar contact={contact} size="x-small" isNonContactUiEnabled={isNonContactUiEnabled} showGmailBrandmark={showGmailBrandmark} />
      <div>
        <BodyText><FullStoryMask>{displayLabel}</FullStoryMask></BodyText>
      </div>
    </ContactContainer>;
};
export const ContactTag = ({
  item,
  onDelete,
  isSingle,
  isDisabled,
  isInvalid = false
}) => {
  const isNonContactUiEnabled = useNewCode(CRM_NEEDS_ATTENTION_FLAG_KEY)?.enabled;
  const isNonContact = isNonContactUiEnabled && isTypedNonContactRecipient(item);
  const isGmail = isNonContactUiEnabled && isGmailRecipientWithBrandmark(item);
  const displayName = isNonContact ? getNonContactRecipientLabel(item) : getContactDisplayName(item);
  return <Container isInvalid={isInvalid} isSingle={isSingle} isNonContact={isNonContact} isGmail={isGmail} data-testid="contact-tag" data-non-contact={isNonContact ? 'true' : 'false'} data-gmail-chip={isGmail ? 'true' : 'false'}>
      <ContactItem contact={item} isNonContactUiEnabled={isNonContactUiEnabled} />
      {(!isSingle || !isDisabled) && <div>
          <DeleteTagButton aria-label={`${I18n.t('action.remove')} ${displayName}`} onClick={onDelete} data-component="contact-item">
            {isSingle ? <CloseCircleIcon color={colorTextSecondary} /> : <CloseMiniIcon />}
          </DeleteTagButton>
        </div>}
    </Container>;
};

require("./contact_tag.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./contact_tag.js");